import React from 'react'
import { useSelector } from 'react-redux'

import { adsenseUserState } from '../../selectors/user'

const GOOGLE_TAG_MANAGER_ID = 'GTM-5FDJPTT'
const GOOGLE_TAG_MANAGER_SCRIPT_ID = 'google-tag-manager'

const GoogleTagManager = () => {
  const {
    isLoading,
    isUserLoaded,
    hasUserError,
    isLoggedIn,
    isPaidUser,
  } = useSelector(adsenseUserState)
  const shouldLoad =
    !isLoggedIn || (isUserLoaded && !isLoading && !hasUserError && !isPaidUser)

  React.useEffect(() => {
    if (!shouldLoad || document.getElementById(GOOGLE_TAG_MANAGER_SCRIPT_ID)) {
      return
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })

    const script = document.createElement('script')
    script.async = true
    script.id = GOOGLE_TAG_MANAGER_SCRIPT_ID
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_MANAGER_ID}`
    document.head.appendChild(script)
  }, [shouldLoad])

  return null
}

export default GoogleTagManager
